import styled from '../../../../../theme'

const SidebarHeaderLabel = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: #323232;
  white-space: nowrap;
`
export default SidebarHeaderLabel
